@if (windowService.isDesktopRes) {
  <tidy-desktop-header #guestsHeader>
    <div class="wrappable-container">
      <tidy-text
        [header]="'Guests/Tenants'" />
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search" />
      </form>
    </div>
  </tidy-desktop-header>
}

<!-- Skeleton table while loading — rows float in with the entrance cascade;
     the real table below then replaces it in place, instantly (skipEntrance). -->
@if (windowService.isDesktopRes && !loaded) {
  <tidy-table
    [skeletonLoading]="true"
    [columnslabels]="headers" />
}

@if (!windowService.isDesktopRes && !loaded) {
  <div style="width: 100%">
    <ion-skeleton-text animated="true" style="height: 75px; border-radius: 6px" />
  </div>
  <div style="width: 100%; padding-top: 1rem;">
    <ion-skeleton-text animated="true" style="height: 200px; border-radius: 6px" />
  </div>
}

@if (!windowService.isDesktopRes && loaded && allRows.length > 0) {
  <form [formGroup]="searchForm" novalidate action="#" style="margin-bottom: 10px;">
    <tidy-search-input
      formControlName="search"
      [placeholder]="'Search'"
      [icon]="'assets/img/search-header.svg'"
      class="header-search" />
  </form>
}

@if (loaded && shownRows.length === 0 && allRows.length === 0) {
  <tidy-card>
    <tidy-row>
      <tidy-text
        [body]="'No guests or tenants found.'" />
    </tidy-row>
    <tidy-row>
      <tidy-text
        [body]="'Connect a booking channel or set up WiFi Marketing to automatically collect guest contact info.'" />
    </tidy-row>
    <tidy-row>
      <tidy-text
        [actionBody]="'Set Up WiFi Marketing'"
        (action)="goToWifiMarketing()"
        class="white-link" />
    </tidy-row>
  </tidy-card>
}

@if (loaded && shownRows.length > 0 && windowService.isDesktopRes) {
  <tidy-card class="no-padding">
    <tidy-table
      #tidyTable
      [dataSource]="shownRows"
      [displayedColumns]="headers"
      [columnslabels]="headers"
      [allRowIsClickable]="true"
      (cellClick)="onRowClick($event)"
      [skipEntrance]="true"
      (sortChange)="sortChanged($event)" />
  </tidy-card>
}

@if (loaded && shownRows.length > 0 && !windowService.isDesktopRes) {
  @for (row of shownRows; track $index) {
    <tidy-card (click)="openContact(row)">
      <tidy-row>
        <tidy-text
          [header]="row['Name'].value"
          [translate]="false" />
      </tidy-row>
      @if (row['Email']?.value) {
        <tidy-row>
          <tidy-text
            [body]="row['Email'].value"
            [translate]="false" />
        </tidy-row>
      }
      @if (row['Phone']?.value) {
        <tidy-row>
          <tidy-text
            [helper]="row['Phone'].value"
            [translate]="false" />
        </tidy-row>
      }
      @if (row['Properties']?.length) {
        <tidy-row>
          <tidy-text
            [helper]="row['Properties'][0]?.value"
            [translate]="false" />
        </tidy-row>
      }
    </tidy-card>
  }
}

@if (loaded && shownRows.length === 0 && allRows.length > 0) {
  <tidy-card>
    <tidy-row [align]="'center'">
      <tidy-text
        [body]="'No results match your search.'" />
    </tidy-row>
  </tidy-card>
}

@if (errorMessage) {
  <tidy-error-message
    [text]="errorMessage" />
}

@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'guests'" [overlayTop]="overlayTop" (dismissed)="dismissAboutThisPage()" />
}
